import { haveSameElements } from "app/pages/sales-intelligence/utils/arrays";
import { buildInclusionConditionKey } from "app/pages/sales-intelligence/utils/inclusionConditionKey";

import type { ISiteTagsDto } from "../types/filter-values";

export const getSiteTagsConditionKey = (item: ISiteTagsDto): string =>
    buildInclusionConditionKey(item.inclusion, item.values);

export const hasSameSiteTagsObject = (item: ISiteTagsDto, comparedItem: ISiteTagsDto | null): boolean => {
    if (comparedItem === null) {
        return false;
    }

    return item.inclusion === comparedItem.inclusion && haveSameElements(item.values, comparedItem.values);
};
